export interface RegionData {
  id: string;
  count: number;
  isoCode: string;
  label: string;
  population?: number;
}

export interface TownData {
  id: string;
  count: number;
  label: string;
  lat: number;
  lng: number;
  population?: number;
}

export interface CountryData {
  id: string;
  count: number;
  label: string;
  population?: number;
}

export type GeoData = RegionData | CountryData | TownData;

export function isCountryData(
  mode: Mode,
  data: GeoData[]
): data is CountryData[] {
  return mode === "countries";
}

export function isRegionData(
  mode: Mode,
  data: GeoData[]
): data is RegionData[] {
  return mode === "regions";
}

export function isTownData(mode: Mode, data: GeoData[]): data is TownData[] {
  return mode === "towns";
}

export type Mode = "countries" | "regions" | "towns";

const COEFF_POPULATION_COUNTRIES = 100000;
const COEFF_POPULATION_TOWNS = 10000;
const COEFF_POPULATION_PROVINCES = 100000;

export function getCountFromMode(
  data: GeoData,
  mode: Mode,
  usePopulation?: boolean
) {
  if (data) {
    const coeff =
      mode === "countries"
        ? COEFF_POPULATION_COUNTRIES
        : mode === "regions"
        ? COEFF_POPULATION_PROVINCES
        : COEFF_POPULATION_TOWNS;
    return usePopulation
      ? data.population > coeff
        ? data.count / (data.population / coeff)
        : 0
      : data.count;
  } else {
    return 0;
  }
}
